import { Team, User } from 'api/models';
import {
  AllocationEvent,
  UserAllocationEvent,
  TeamAllocationEvent,
} from 'components/organisms/resource-management/event-types';
import { mergeAllocations } from 'components/organisms/resource-management/utils/merge-allocation';
import { WorkingDaysConfiguration } from 'components/organisms/user-capacity';
import { TemplateAssignee } from '../types';

const mergeAllocationsForUsers =
  (users: User[], workingDaysConfig: WorkingDaysConfiguration) =>
  (allAllocations: AllocationEvent[]): AllocationEvent[] =>
    users.reduce((allocations, user) => {
      const userEvents = allAllocations.filter(
        (x) => (x as UserAllocationEvent).userId === user.userId,
      );

      if (userEvents.length === 0) {
        return allocations;
      }

      return allocations.concat(
        mergeAllocations(userEvents, workingDaysConfig),
      );
    }, [] as AllocationEvent[]);
const mergeAllocationsForTeams =
  (teams: Team[], workingDaysConfig: WorkingDaysConfiguration) =>
  (allAllocations: AllocationEvent[]): AllocationEvent[] =>
    teams.reduce((allocations, team) => {
      const teamEvents = allAllocations.filter(
        (x) => (x as TeamAllocationEvent).teamId === team.teamId,
      );

      if (teamEvents.length === 0) {
        return allocations;
      }

      return allocations.concat(
        mergeAllocations(teamEvents, workingDaysConfig),
      );
    }, [] as AllocationEvent[]);

export const mergeAllocationsForAssignee =
  (
    allTasksAssignees: TemplateAssignee,
    workingDaysConfig: WorkingDaysConfiguration,
  ) =>
  (allAllocations: AllocationEvent[]): AllocationEvent[] =>
    mergeAllocationsForUsers(
      allTasksAssignees.users,
      workingDaysConfig,
    )(allAllocations).concat(
      mergeAllocationsForTeams(
        allTasksAssignees.teams,
        workingDaysConfig,
      )(allAllocations),
    );
